import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IspvisionService, VisionWs } from 'src/app/core/services/ispvision.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'order-details',
    templateUrl: './details.component.html',
    styleUrls: ['./details.component.less'],
    encapsulation: ViewEncapsulation.ShadowDom,
})
export class OrderDetailsComponent implements OnInit {
    constructor(
        private activatedRoute: ActivatedRoute,
        public visionWs: IspvisionService,
        private router: Router,
        private sanitizer: DomSanitizer
    ) {
        this.activatedRoute.data.subscribe((data) => {
            this.visionWs.setFormPartitioning(data['type']);
        });
    }
    public orderId: number;
    public order: VisionWs.OrderResponse;
    public loaded: boolean = false;
    public table: SafeHtml;
    public navPath: string = 'markiezen';
    async ngOnInit(): Promise<void> {
        this.activatedRoute.data.subscribe((data) => {
            if (data['type'] === 'kokers') {
                this.navPath = 'kokers-en-profielen';
            }
            this.visionWs.setFormPartitioning(data['type']);
        });

        this.orderId = Number.parseInt(this.activatedRoute.snapshot.paramMap.get('orderId'));
        //check if this order is valid
        this.order = await this.visionWs.getOrder(this.orderId);
        if (this.order.error_code < 0) {
            this.router.navigate(['/orders']);
            return;
        }
        if (this.order.is_concept) {
            this.visionWs.isConcept = true;
            this.visionWs.conceptId = this.orderId;
            this.router.navigate(['/' + this.navPath + '/configurator']);
        }
        this.loaded = true;
        this.table = this.sanitizer.bypassSecurityTrustHtml(this.order.email_html);
    }
}
